import { axiosAuth } from './axiosInstances'

// KHAN-233: api/classes/{createClasses,listedClasses,changeClasses,
// deleteClasses,listedClassesid,getClassById} -> recurso REST api/classes/
// con metodo HTTP por operacion. createdat/lastupdateat ya no se mandan: el
// backend los fija server-side.

export async function newClass(
  name,
  grade,
  teacherassigned,
  startdate,
  finishdate,
  groupscreateid,
  isactive
) {

  return axiosAuth().post('classes/', {
    name: name,
    grade: grade,
    teacherAssigned: teacherassigned,
    startdate: startdate,
    finishdate: finishdate,
    groupscreateid: groupscreateid,
    isactive: isactive,
  })
}

export async function listedclasses() {
  return axiosAuth().get('classes/')
}

// createdat/lastupdateat se conservan en la firma para no tocar a los
// callers, pero ya no se envian (los fija el backend).
export async function classesChange(
  classesId,
  name,
  grade,
  teacherAssigned,
  createdat,
  lastupdateat,
  startdate,
  finishdate,
  groupscreateid,
  isactive
) {
  return axiosAuth().patch(`classes/${classesId}/`, {
    name: name,
    grade: grade,
    teacherAssigned: teacherAssigned,
    startdate: startdate,
    finishdate: finishdate,
    groupscreateid: groupscreateid,
    isactive: isactive,
  })
}

export async function deleteclasses(classesId) {
  return axiosAuth().delete(`classes/${classesId}/`)
}

export async function listedClassesId(group) {
  // Audit fix: axios drops an undefined/null param, which would turn this
  // into an UNFILTERED `GET classes/` (every class of every teacher). The old
  // POST with {group: undefined} filtered on a NULL group and came back
  // empty, so answer with an empty list instead.
  if (group === undefined || group === null || group === '') {
    return { data: [] }
  }
  return axiosAuth().get('classes/', {
    params: { group: group },
  })
}

export async function getClassById(classId) {
  return axiosAuth().get(`classes/${classId}/`)
}
